module.exports = __webpack_public_path__ + "fonts/98291d65d7c5a049c81e8f5d786eec98.eot";